
import { Vue, Component, Emit } from 'vue-property-decorator';
import { fetchBanners } from '@/services/userService';

@Component
export default class FloatingBanner extends Vue {
  private fBanner: BannerData[] = [];
  private showFBanner: boolean = true;
  
  get banner(): BannerData {
    const max = this.fBanner.length;
    const min = 0;
    const ran = Math.floor(Math.random() * ( (max) - min ) + min);
    return this.fBanner[ran];
  }

  get token(): boolean {
    return this.$store.getters['auth/token'];
  }

  get hasFbanner(): boolean {
    return (this.fBanner.length > 0 && this.showFBanner) ? true : false;
  }

  @Emit()
  private closefBanner() {
    this.showFBanner = false;
    this.$emit('changeFbannerVar', false);
  }

  @Emit()
  private async getfBanner() {
    try {
      const res = await fetchBanners({cat:'is-login'});
      this.fBanner = res;
    } catch (error) {
      console.warn(error)
    } finally {
      this.$emit('changeFbannerVar', this.hasFbanner);
    }
  }

  private mounted() {
    this.getfBanner();
  }
}
